import { handleBreakpoints as e, values as t } from "./index33.js";
import n from "./index35.js";
import r from "./index39.js";
//#region ../../node_modules/.pnpm/@mui+system@7.3.9_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+st_bd245af145176c4b13a339c35b364ace/node_modules/@mui/system/esm/sizing/sizing.js
function i(e) {
	return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
var a = n({
	prop: "width",
	transform: i
}), o = (n) => n.maxWidth !== void 0 && n.maxWidth !== null ? e(n, n.maxWidth, (e) => {
	let r = n.theme?.breakpoints?.values?.[e] || t[e];
	return r ? n.theme?.breakpoints?.unit === "px" ? { maxWidth: r } : { maxWidth: `${r}${n.theme.breakpoints.unit}` } : { maxWidth: i(e) };
}) : null;
o.filterProps = ["maxWidth"];
var s = n({
	prop: "minWidth",
	transform: i
}), c = n({
	prop: "height",
	transform: i
}), l = n({
	prop: "maxHeight",
	transform: i
}), u = n({
	prop: "minHeight",
	transform: i
});
n({
	prop: "size",
	cssProperty: "width",
	transform: i
}), n({
	prop: "size",
	cssProperty: "height",
	transform: i
}), r(a, o, s, c, l, u, n({ prop: "boxSizing" }));
//#endregion
export { o as maxWidth, i as sizingTransform };

//# sourceMappingURL=index43.js.map